import { render, staticRenderFns } from "./BotonCompraNormal.vue?vue&type=template&id=5b0e59a6"
import script from "./BotonCompraNormal.vue?vue&type=script&lang=js"
export * from "./BotonCompraNormal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports